import $ from 'jquery';

export default class PreviewUploadedImage {
  constructor(root) {
    $(root).on('change', '.js__gift-file-upload', e => {
      this.displayUploadedImage(e.currentTarget);
    });
  }

  displayUploadedImage(input) {
    if (input.files && input.files[0]) {
      const reader = new FileReader();

      reader.onload = event => {
        const image = $(input).parent().siblings('.img-wrapper');

        if (image.length > 0) {
          image.find('img').attr('src', event.target.result);
        } else {
          const img = $('<div class="img-wrapper"><img class="image"/></div>');
          img.find('img').attr('src', event.target.result);

          $(input).parent().parent().prepend(img);
        }
      };

      reader.readAsDataURL(input.files[0]);
    }
  }
}
